import { a as M, j as e } from "../../../jsx-runtime-c20f6c15.mjs";
import I from "clsx";
import { useState as Q, useEffect as S } from "react";
import j from "../../../shared/icons/add-fill.svg.mjs";
import q from "../../../shared/icons/minus-fill.svg.mjs";
import x from "../../../shared/icons/trash-bin-outline-1.svg.mjs";
import y from "../Button/Button.mjs";
import B from "../BodyText/BodyText.mjs";
import "../Spinner/Spinner.mjs";
const F = "_container_pp56v_1", O = "_modifierIcon_pp56v_22", P = "_trashIcon_pp56v_27", T = "_disabled_pp56v_32", o = {
  container: F,
  modifierIcon: O,
  trashIcon: P,
  disabled: T
}, w = 100;
function A(t, i, a) {
  return a ? t < a ? a : t : i && t > i ? 1 : t;
}
function W({
  disabled: t = !1,
  value: i,
  initialValue: a = 1,
  max: f = w,
  min: c = 1,
  step: n = 1,
  onChange: r,
  withRemoveOption: v = !1,
  className: b,
  renderQuantity: _
}) {
  const [s, l] = Q(
    A(a, f, c)
  ), u = s === f, p = s === c, N = v && s === c;
  function k(m) {
    if (m.stopPropagation(), !(u || t))
      if (s + n > f)
        l(f), r == null || r(f, !0);
      else {
        const d = s + n;
        l(d), r == null || r(d, !0);
      }
  }
  function D(m) {
    if (m.stopPropagation(), !(p || t))
      if (s - n < c)
        l(c), r == null || r(c, !1);
      else {
        const d = s - n;
        l(d), r == null || r(d, !1);
      }
  }
  return S(() => {
    i !== void 0 && l(i);
  }, [i]), /* @__PURE__ */ M("div", { className: I(o.container, b), children: [
    /* @__PURE__ */ e(
      y,
      {
        disabled: p || t,
        variant: "secondary",
        onClick: D,
        className: I({
          [o.disabled]: p || t
        }),
        "aria-label": "Decrease quantity",
        children: N ? /* @__PURE__ */ e(x, { className: o.trashIcon, "aria-hidden": !0 }) : /* @__PURE__ */ e(q, { className: o.modifierIcon, "aria-hidden": !0 })
      }
    ),
    /* @__PURE__ */ e(B, { children: _ ? _(s) : s }),
    /* @__PURE__ */ e(
      y,
      {
        disabled: u || t,
        variant: "secondary",
        onClick: k,
        className: I({
          [o.disabled]: u || t
        }),
        "aria-label": "Increase quantity",
        children: /* @__PURE__ */ e(j, { className: o.modifierIcon })
      }
    )
  ] });
}
export {
  w as QuantityModifierMax,
  W as default
};
